import { isEmpty } from "heliocor-ui"

export const areFormErrorsEmpty = errors => {
    return (isEmpty(errors) || (!isEmpty(errors) && Object.keys(errors).every(k => isEmpty(errors[k]))))
}